import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=927b1854&scoped=true&"
var script = {}
import style0 from "./ModalFooter.vue?vue&type=style&index=0&id=927b1854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927b1854",
  null
  
)

export default component.exports